import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ.js";
import {useNavigate} from "react-router-dom";
import "./IoTStyles.css";
function IoTGateways() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchGateways = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                baseUrl + "iot-gateways/"
            );
            setRows(response.data);
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to load gateways.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchGateways();
    }, []);
    const deleteGateway = async (id) => {
        const result = await Swal.fire({
            title: "Delete Gateway?",
            text: "Connected device relationships may be affected.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete"
        });
        if (!result.isConfirmed) {
            return;
        }
        try {
            await axios.delete(
                baseUrl +
                "iot-gateways/" +
                id +
                "/"
            );
            Swal.fire(
                "Deleted",
                "Gateway deleted successfully.",
                "success"
            );
            fetchGateways();
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to delete gateway.",
                "error"
            );
        }
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70
        },
        {
            field: "gateway_id",
            headerName: "Gateway ID",
            width: 160
        },
        {
            field: "gateway_name",
            headerName: "Gateway Name",
            width: 200
        },
        {
            field: "ip_address",
            headerName: "IP Address",
            width: 150
        },
        {
            field: "port",
            headerName: "Port",
            width: 90
        },
        {
            field: "hospital_code",
            headerName: "Hospital",
            width: 130
        },
        {
            field: "location",
            headerName: "Location",
            width: 150
        },
        {
            field: "version",
            headerName: "Version",
            width: 110
        },
        {
            field: "status",
            headerName: "Status",
            width: 120,
            renderCell: (params) => (
                <span
                    className={
                        params.value === "ONLINE"
                            ? "iot-status online"
                            : params.value === "MAINTENANCE"
                                ? "iot-status maintenance"
                                : "iot-status offline"
                    }
                >
                    {params.value}
                </span>
            )
        },
        {
            field: "last_seen",
            headerName: "Last Seen",
            width: 190
        },
        {
            field: "actions",
            headerName: "Action",
            width: 220,
            sortable: false,
            renderCell: (params) => (
                <div className="iot-action-buttons">

                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() =>
                            navigate(
                                "/iot-gateway-form/" +
                                params.row.id
                            )
                        }
                    >
                        Edit
                    </button>


                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() =>
                            deleteGateway(
                                params.row.id
                            )
                        }
                    >
                        Delete
                    </button>

                </div>
            )
        }
    ];
    return (
        <section className="container-fluid mt-4">

            <div className="iot-page-header">

                <div>

                    <h3>
                        IoT Gateways
                    </h3>

                    <p>
                        Manage DrGHiS hospital IoT gateways
                    </p>

                </div>


                <button
                    className="btn btn-success"
                    onClick={() =>
                        navigate(
                            "/iot-gateway-form/"
                        )
                    }
                >
                    + Add Gateway
                </button>

            </div>


            <div className="card shadow-sm">

                <div className="card-body">

                    <DataGrid

                        rows={rows}

                        columns={columns}

                        loading={loading}

                        autoHeight

                        pageSizeOptions={[
                            10,
                            25,
                            50
                        ]}

                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                    page: 0
                                }
                            }
                        }}

                        slots={{
                            toolbar: GridToolbar
                        }}

                        sx={{
                            boxShadow: 3
                        }}

                    />

                </div>

            </div>

        </section>
    );
}
export default IoTGateways;
